import * as types from '../mutation-types'
import UsersService from '~/services/users';

// state
export const state = {
  statistics: [],
  collection: [],
  model: null,
};

// getters
export const getters = {
  statistics: state => state.statistics,
  users: state => state.collection,
  user: state => state.model,
};

// mutations
export const mutations = {
  [types.USERS_FETCH_ALL] (state, users) {
    state.collection = users;
  },
  [types.USERS_CLEAR] (state) {
    state.model = null;
  },
  [types.USERS_CLEAR_ALL] (state) {
    state.collection = []
  },
  [types.USERS_CLEAR_STATS] (state) {
    state.statistics = []
  },
  [types.USERS_FIND] (state, user) {
    state.model = user;
  },
  [types.USERS_STATS] (state, statistics) {
    state.statistics = statistics;
  },
  [types.USERS_CREATE] (state, user) {
    state.collection.push(user);
  },
  [types.USERS_UPDATE] (state, user) {
    let index = state.collection.findIndex(el => el.id === user.id);

    if (index !== -1) {
      state.collection[index] = user;
    }
  },
  [types.USERS_REMOVE] (state, userId) {
    state.collection.splice(state.collection.findIndex(u => parseInt(u.id) === parseInt(userId)), 1);
  },
};

// actions
export const actions = {
  async fetchAll ({ commit }) {
      const users = await UsersService.fetchAll();
      commit(types.USERS_FETCH_ALL, users);
  },
  clearUser ({ commit }) {
    commit(types.USERS_CLEAR);
  },
  clearStats ({ commit }) {
    commit(types.USERS_CLEAR_STATS);
  },
  clearUsers ({ commit }) {
    commit(types.USERS_CLEAR_ALL);
  },
  async find ({ commit }, userId) {
    const user = await UsersService.getUser(userId);
    commit(types.USERS_FIND, user);
  },
  async getStats ({ commit }, userId) {
    const statistics = await UsersService.getUserStatistics(userId);
    commit(types.USERS_STATS, statistics);
  },
  async create ({ commit }, form) {
    const user = await UsersService.createUser(form);
    commit(types.USERS_CREATE, user);
  },
  async update ({ commit }, form) {
    const user = await UsersService.updateUser(form);
    commit(types.USERS_UPDATE, user);
  },
  async remove ({ commit }, userId) {
    await UsersService.removeUser(userId);
    commit(types.USERS_REMOVE, userId);
  },
};
